import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "api-url" }
const _hoisted_4 = { class: "url-start-from" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "checkbox-container" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "visibility-radio-container" }
const _hoisted_9 = { class: "format-selector" }
const _hoisted_10 = {
  class: "format-option",
  style: {"min-width":"80px"}
}
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { class: "type-radio-container" }
const _hoisted_13 = { class: "format-selector" }
const _hoisted_14 = {
  class: "format-option",
  style: {"min-width":"80px"}
}
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "format-radio-container" }
const _hoisted_17 = { class: "format-selector" }
const _hoisted_18 = {
  class: "format-option",
  style: {"min-width":"80px"}
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = { class: "format-option" }
const _hoisted_21 = ["disabled"]
const _hoisted_22 = {
  class: "format-option",
  style: {"min-width":"110px"}
}
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "your-data" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 0,
  class: "api-endpoint-url"
}
const _hoisted_27 = {
  key: 2,
  class: "api-endpoint-url"
}
const _hoisted_28 = {
  key: 3,
  class: "usage-block"
}
const _hoisted_29 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_2, [
      _cache[21] || (_cache[21] = _createElementVNode("h2", { class: "create-api-text" }, " Create New API ", -1)),
      _cache[22] || (_cache[22] = _createElementVNode("h4", { class: "api-endpoint-url" }, " API Endpoint URL ", -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(this.baseUrl + this.randomUrlPart), 1),
        _withDirectives(_createElementVNode("input", {
          class: "url-ends-input",
          type: "text",
          placeholder: "enter-you-url-part-here",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userUrl) = $event)),
          disabled: !_ctx.canCreate
        }, null, 8, _hoisted_5), [
          [_vModelText, _ctx.userUrl]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "checkbox-add-random",
          class: "checkbox-add-random styled-checkbox",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.checkboxRandom) = $event)),
          disabled: !_ctx.canCreate
        }, null, 8, _hoisted_7), [
          [_vModelCheckbox, _ctx.checkboxRandom]
        ]),
        _cache[10] || (_cache[10] = _createElementVNode("label", {
          for: "checkbox-add-random",
          class: "checkbox-label"
        }, " Add Random Prefix ", -1))
      ]),
      _cache[23] || (_cache[23] = _createElementVNode("h4", { class: "api-endpoint-url" }, " Visibility ", -1)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("label", _hoisted_10, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "visibility-selector",
              value: "public",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.visibility) = $event)),
              checked: "",
              disabled: !_ctx.canCreate
            }, null, 8, _hoisted_11), [
              [_vModelRadio, _ctx.visibility]
            ]),
            _cache[11] || (_cache[11] = _createElementVNode("span", { class: "radio-circle" }, null, -1)),
            _cache[12] || (_cache[12] = _createElementVNode("span", { class: "format-label" }, "Public", -1))
          ])
        ])
      ]),
      _cache[24] || (_cache[24] = _createElementVNode("h4", { class: "api-endpoint-url" }, " Type ", -1)),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("label", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "type-selector",
              value: "static",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.type) = $event)),
              checked: "",
              disabled: !_ctx.canCreate
            }, null, 8, _hoisted_15), [
              [_vModelRadio, _ctx.type]
            ]),
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "radio-circle" }, null, -1)),
            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "format-label" }, "Static", -1))
          ])
        ])
      ]),
      _cache[25] || (_cache[25] = _createElementVNode("h4", { class: "api-endpoint-url" }, " Response Format ", -1)),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("label", _hoisted_18, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "format-selector",
              value: "json",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.responseFormat) = $event)),
              disabled: !_ctx.canCreate
            }, null, 8, _hoisted_19), [
              [_vModelRadio, _ctx.responseFormat]
            ]),
            _cache[15] || (_cache[15] = _createElementVNode("span", { class: "radio-circle" }, null, -1)),
            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "format-label" }, "JSON", -1))
          ]),
          _createElementVNode("label", _hoisted_20, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "format-selector",
              value: "html",
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.responseFormat) = $event)),
              disabled: !_ctx.canCreate
            }, null, 8, _hoisted_21), [
              [_vModelRadio, _ctx.responseFormat]
            ]),
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "radio-circle" }, null, -1)),
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "format-label" }, "HTML", -1))
          ]),
          _createElementVNode("label", _hoisted_22, [
            _withDirectives(_createElementVNode("input", {
              type: "radio",
              name: "format-selector",
              value: "plain",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.responseFormat) = $event)),
              disabled: !_ctx.canCreate
            }, null, 8, _hoisted_23), [
              [_vModelRadio, _ctx.responseFormat]
            ]),
            _cache[19] || (_cache[19] = _createElementVNode("span", { class: "radio-circle" }, null, -1)),
            _cache[20] || (_cache[20] = _createElementVNode("span", { class: "format-label" }, "Plain Text", -1))
          ])
        ])
      ]),
      _cache[26] || (_cache[26] = _createElementVNode("h4", { class: "api-endpoint-url" }, " Write Your Data ", -1)),
      _createElementVNode("div", _hoisted_24, [
        _withDirectives(_createElementVNode("textarea", {
          rows: "10",
          class: "your-data-textarea",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.responseData) = $event)),
          disabled: !_ctx.canCreate
        }, null, 8, _hoisted_25), [
          [_vModelText, _ctx.responseData]
        ])
      ]),
      _createElementVNode("button", {
        class: _normalizeClass([{
              'create-button_idle': _ctx.canCreate,
              'create-button_blocked': !_ctx.canCreate,
              'create-button_success': _ctx.isSuccess,
              'create-button_error': _ctx.isError
            }, "create-button"]),
        onClick: _cache[8] || (_cache[8] = () => _ctx.canCreate && _ctx.submitData())
      }, _toDisplayString(_ctx.buttonText), 3),
      (_ctx.usage)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_26, " Open in Terminal via Curl "))
        : _createCommentVNode("", true),
      (_ctx.usage)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "usage-block",
            onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.copyToClipboard && _ctx.copyToClipboard(...args)))
          }, " curl -X GET " + _toDisplayString(_ctx.usage) + " --output - ", 1))
        : _createCommentVNode("", true),
      (_ctx.usage)
        ? (_openBlock(), _createElementBlock("h4", _hoisted_27, " Open in Web Browser "))
        : _createCommentVNode("", true),
      (_ctx.usage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
            _createElementVNode("a", {
              href: _ctx.usage,
              target: "_blank",
              style: {"color":"white"}
            }, _toDisplayString(_ctx.usage), 9, _hoisted_29)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}